import store from "../store/index";
import history from "./history";
import moment from "moment";
import * as jsPDF from 'jspdf'
import * as ICS from 'ics-js';
import { TimelineMax } from "gsap/TweenMax";
import apiInvoker from "./apiInvoker.js";

/* Mocks */
import { excludedCapsMock } from './mocks/excludedCaps';

const fa_path = '/fissa-appuntamento';

const utils = {
  getFaPath() {
    return fa_path;
  },
  goTo(pagina) {
    history.push(pagina);
  },
  getTimestamp() {
    return moment().unix();
  },

  //goToPage(pagina, domain, qs) {
  //  let pathname = pagina.replace(domain, '');

  //  if (!pathname) {
  //    pathname = '/';
  //  }

  //  if (qs) {
  //    pagina = pagina + "?" + qs;
  //  }

  //  importDataQualityPixel(pathname);

  //  history.push(pagina);
  //},
  //getCurrentStep() { //Funzione che determina lo step corrente del flusso
  //  const stato_appuntamento = store.getState();
  //  const from_last_change = moment().diff(moment.unix(stato_appuntamento.last_back_timestamp));
  //  if (!stato_appuntamento.last_back_timestamp || from_last_change > 1000) {
  //    store.dispatch(setLastBackTimestamp())
  //    let qs = window.localStorage.getItem("qs") || "";
  //    if (!window.localStorage.getItem("pending_qs_remove")) {
  //      let qs_params = window.document.location.href.split("?")[1];
  //      if (qs_params && qs_params != "") {
  //        qs = window.document.location.href.split("?")[1];
  //      }
  //    } else {
  //      window.localStorage.removeItem("pending_qs_remove")
  //    }
  //    if (qs) {
  //      window.localStorage.setItem("qs", qs);
  //    }
  //    let pagina = fa_path;
  //    //Abbiamo tutti i dati necessari per l'appuntamento, vado al riepilogo
  //    // ! La condizione !stato_appuntamento.utente.token serve per i casi in cui, grazie ai parametri, si vuole andare direttamente in Thank You Page.
  //    // ! Fa si che si passi prima da "dati-personali", venga fatto scattare il servizio "Crea appuntamento" e nel caso di successo solo allora si verra reindirizzati alla Thank You.
  //    if (
  //      typeof stato_appuntamento.recap_cf_accettato != "undefined"
  //      //&& stato_appuntamento.recap_cf_accettato
  //      && stato_appuntamento.utente.consensi
  //      && typeof stato_appuntamento.utente.consensi.informativa != "undefined"
  //      && typeof stato_appuntamento.utente.consensi.dati_personali != "undefined"
  //      && typeof stato_appuntamento.utente.consensi.societa_terze != "undefined"
  //      && stato_appuntamento.utente.nome && stato_appuntamento.utente.nome != ""
  //      && stato_appuntamento.utente.cognome && stato_appuntamento.utente.cognome != ""
  //      && stato_appuntamento.utente.email && stato_appuntamento.utente.email != ""
  //      && stato_appuntamento.utente.telefono && stato_appuntamento.utente.telefono != ""
  //      && stato_appuntamento.utente.cap && stato_appuntamento.utente.cap != ""
  //      && ((stato_appuntamento.data_appuntamento && stato_appuntamento.data_appuntamento != "") || stato_appuntamento.prodotto == 3 || stato_appuntamento.prodotto == 5 || stato_appuntamento.prodotto == -2)
  //      && stato_appuntamento.filiale && stato_appuntamento.filiale != ""
  //      && stato_appuntamento.orario_appuntamento && stato_appuntamento.orario_appuntamento != ""
  //      && (!stato_appuntamento.utente.token || stato_appuntamento.utente.token === "")
  //    ) {
  //      pagina = fa_path + "/thank-you-page";
  //      if (this.getState().prodotto == 3) {
  //        pagina = fa_path + "/thank-you-page-CQ";
  //      } else if (this.getState().prodotto == 5) {
  //        pagina = fa_path + "/thank-you-page-AUP";
  //      } else if (this.getState().prodotto == -2) {
  //        pagina = fa_path + "/typ_RICHIAMAMI";
  //      }else if (this.getState().flusso_modifica && !this.getState().modificando) {
  //        pagina = fa_path + "/riepilogo-modifica-appuntamento";
  //      } else if (this.getState().flusso_modifica && this.getState().modificando) {
  //        pagina = fa_path + "/conferma-modifica-appuntamento";
  //      }
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Ho il codice fiscale ma o non l'email o ho un numero di telefono fisso, passo alla compilazione dei dati personali
  //    //Il prodotto è contact center
  //    if (
  //      typeof stato_appuntamento.recap_cf_accettato != "undefined"
  //      && stato_appuntamento.utente
  //      && stato_appuntamento.utente.codice_fiscale
  //      && stato_appuntamento.filiale
  //      && stato_appuntamento.filiale != ""
  //      && stato_appuntamento.prodotto == -2
  //    ) {
  //      pagina = fa_path + "/dati-personali-richiamami";
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Ho il codice fiscale ma o non l'email o ho un numero di telefono fisso, passo alla compilazione dei dati personali
  //    if (
  //      typeof stato_appuntamento.recap_cf_accettato != "undefined"
  //      && stato_appuntamento.recap_cf_accettato == false
  //      && stato_appuntamento.utente
  //      && stato_appuntamento.utente.codice_fiscale
  //      && stato_appuntamento.filiale
  //      && stato_appuntamento.filiale != ""
  //    ) {
  //      pagina = fa_path + "/dati-personali-riconosciuto";
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Ho il codice fiscale ma o non l'email o ho un numero di telefono fisso, passo alla compilazione dei dati personali
  //    if (
  //      typeof stato_appuntamento.recap_cf_accettato != "undefined"
  //      && stato_appuntamento.utente
  //      && stato_appuntamento.utente.codice_fiscale
  //      && stato_appuntamento.filiale
  //      && stato_appuntamento.filiale != ""
  //    ) {
  //      pagina = fa_path + "/dati-personali";
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Ho filiale e orario, vado all'inserimento del codice fiscale
  //    if (
  //      stato_appuntamento.filiale
  //      && stato_appuntamento.filiale != ""
  //      && stato_appuntamento.orario_appuntamento
  //      && stato_appuntamento.orario_appuntamento != ""
  //    ) {
  //      pagina = fa_path + "/codice-fiscale";
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Ho il giorno, vado alla scelta della filiale e dell'orario
  //    if (stato_appuntamento.data_appuntamento && stato_appuntamento.data_appuntamento != "") {
  //      pagina = fa_path + "/scelta-filiale";
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Ho il luogo, vado alla scelta del giorno
  //    if (stato_appuntamento.luogo && stato_appuntamento.luogo != "" && stato_appuntamento.prodotto != 5) {
  //      pagina = fa_path + "/data-appuntamento";
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    //Route di appuntamento telefonico forzato
  //    if (window.location.pathname == fa_path + "/scegli-dove") {
  //      pagina = fa_path + "/scegli-dove";
  //      return;
  //    }

  //    //Non è cessione del quinto, continuiamo sul flusso standard
  //    if (
  //      stato_appuntamento.tipo_appuntamento
  //      && stato_appuntamento.prodotto
  //      && stato_appuntamento.prodotto != ""
  //      && stato_appuntamento.prodotto != 3
  //      && stato_appuntamento.prodotto != 5
  //    ) {
  //      pagina = fa_path + "/scegli-luogo";
  //      if (stato_appuntamento.flusso_modifica===true) {
  //        pagina = fa_path + "/data-appuntamento";
  //      }
  //      this.goToPage(pagina, '', qs);
  //      return;
  //    }

  //    this.goToPage(pagina, '', qs);
  //  }
  //},

    getState() {
    return store.getState()
  },
  getUrlParameter(name) {
    let ret = '';
    let params_str = window.document.location.search.replace('?', '');
    let params = params_str.split("&");
    if (params && params.length > 0) {
      params.forEach(function (param_str) {
        let param = param_str.split("=");
        if (param[0] === name) {
          ret = param[1];
        }
      });
    }
    return decodeURIComponent(ret);
  },
  validateCF(val) {
    let valid = false;
    if (val && typeof val == "string" && val.length > 1) {
      var re = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  },
  validateSearch(val) {
    let cap = false;
    let address = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      var reCap = /^[0-9]{5}$/;
      cap = reCap.test(String(val).toLowerCase());
      var reAddress = /^[a-zA-Z ][a-zA-Z ][a-zA-Z 0-9]*$/;
      address = reAddress.test(String(val).toLowerCase());
    }
    return cap || address;
  },
  validateSearch2(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      var re = /^.{3,}$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  },
  padLeft(value) {
    let str = "" + value;
    let pad = "00";
    let ans = pad.substring(0, pad.length - str.length) + str;
    return ans;
  },
  padLeft3(value) {
    let str = "" + value;
    let pad = "000";
    let ans = pad.substring(0, pad.length - str.length) + str;
    return ans;
  },
  showErrorModal(errorText, errorCode) {
    let modal = document.querySelector('.modal-error-container');
    if (modal) {
      let modal_text = document.querySelector('.modal-error .error-text');
      if (modal_text) {
        modal_text.innerText = errorText;
      }
      if (modal) {
        modal.classList.add('is-modal-shown');
      }

      modal.setAttribute('data-error-code', errorCode);
    }
  },
  showMap(address, place, coordinates) {
    const placeInfo = place.split(' - ');
    const city = placeInfo[0];
    const cap = placeInfo[1];

    window.open(
      'https://www.google.it/maps/place/' + address + ',' + city + '/@' + coordinates.lat + ',' + coordinates.lng + ',17z',
      '_blank'
    );
  },
  showRoadIndications(address, place) {
    let global_state = store.getState();
    const daddr = global_state.indirizzo_filiale;
    let saddr = global_state.indirizzo_filiale;
    const location = window.navigator && window.navigator.geolocation;
    if (location) {
      location.getCurrentPosition((position) => {
        saddr = position.coords.latitude + "," + position.coords.longitude;
        window.open('https://www.google.it/maps?saddr=' + saddr + '&daddr=' + daddr + '_blank');
      })
    } else {
      window.open('https://www.google.it/maps?saddr=' + saddr + '&daddr=' + daddr + '_blank');
    }
  },
  addToCalendar() {
    let global_state = store.getState();
    let data_app = global_state.data_appuntamento + " " + global_state.orario_appuntamento;
    let VCALENDAR = ICS.VCALENDAR;
    let VEVENT = ICS.VEVENT;
    let cal = new VCALENDAR();
    let event = new VEVENT();

    cal.addProp('VERSION', 2)
    cal.addProp('PRODID', 'Compass Banca');
    event.addProp('UID');
    event.addProp('DTSTAMP', new Date(data_app), { VALUE: 'DATE-TIME' });
    event.addProp('DTSTART', new Date(data_app), { VALUE: 'DATE-TIME' });
    event.addProp('LOCATION', global_state.indirizzo_filiale);
    event.addProp('SUMMARY', 'Appuntamento in Compass Banca');
    cal.addComponent(event);
    window.open("data:text/calendar;charset=utf8," + escape(cal));
  },
  capitalizeFLetter(str) {
    return str[0].toUpperCase() + str.slice(1);
  },
  printPDF(nome_filiale, indirizzo_filiale, data_str, ora, prodotto) {
    var doc = new jsPDF()

    doc.setFontSize(22);
    doc.setTextColor(204, 0, 0);
    doc.text(30, 30, 'Appuntamento in Compass');
    doc.setFontSize(15);
    doc.setTextColor(51, 51, 51);
    doc.text(30, 55, `Ti aspettiamo in ${ prodotto != 3 ? 'filiale' : 'agenzia' } ` + data_str + `${ ora ? ` alle ${ora}` : ''}`);
    //doc.addImage(imgData, 'JPEG', 30, 70, 530, 300); //350
    doc.setFontSize(15);
    doc.setTextColor(204, 0, 0);
    doc.text(30, 65, nome_filiale);
    doc.setTextColor(51, 51, 51);
    doc.text(30, 75, indirizzo_filiale);
    doc.setTextColor(204, 0, 0);
    doc.text(30, 105, 'Documenti necessari');
    doc.setTextColor(51, 51, 51);
    doc.text(30, 115, "Documento di riconoscimento in corso di validità");
    doc.text(30, 125, "Carta Regionale/Nazionale dei Servizi (Tessera Sanitaria)");
    doc.text(30, 135, "Copia del giustificativo di reddito in possesso al richiedente");
    doc.output("dataurlnewwindow");
  },
  printAppuntamento(nome, telefono, filiale, indirizzo, data, ora, prodotto) {
    let print_body = `
            <!doctype html>
            <html>
                <head>
                    <meta charset="utf-8">
                    <title>Il tuo appuntamento ${ prodotto != 3 ? 'in filiale' : 'in agenzia' } Compass</title>
                    <style>
                        body { text-align: center; font-family: arial; }
                        #logo { margin-bottom: 40px 0 70px; }
                    </style>
                </head>
                <body>
                    <div id="logo">
                        <img src="https://www.compass.it/application/themes/compass/assets/img/loghi/logo-compass-banca.png" />
                    </div>
                    <br/><br/>
                    <h2>TI ASPETTIAMO IN ${ prodotto != 3 ? 'FILIALE' : 'AGENZIA' }</h2>
                    <h5>Ecco il riepilogo del tuo appuntamento</h5>
                    <div class="separatore"></div>
                    <div class="entry">${nome}</div>
                    <div class="entry">${telefono}</div>
                    <br/>
                    <div class="entry">${filiale}</div>
                    <div class="entry">${indirizzo}</div>
                    <br/>
                    <div class="entry">${data}</div>
                    ${ora ? `<div class="entry">${ora}</div>` : '' }
                    <br/><br/>
                    <strong>Documenti necessari</strong><br/>
                    <br/>
                    Documento di riconoscimento in corso di validit&agrave;<br/>
                    <br/>
                    Carta Regionale/Nazionale dei Servizi (Tessera Sanitaria)<br/>
                    <br/>
                    Copia del giustificativo di reddito in possesso al richiedente
                    <script>setTimeout('window.print();',1000);</script>
                <body>
            </html>
        `;
    var wnd = window.open("about:blank", "", "_blank");
    wnd.document.write(print_body);
  },
  scrollToTop() {
    window.scroll(0, 0);
  },
  decodeUTMHistory(enc) {
    var o = enc; if (enc != null && enc.length % 6 == 0) {
      var h = enc.substr(0, enc.length - enc.length % 6); var hp = "";
      for (var i = 6; i < h.length; i += 6) {
        try {
          var x = parseInt(h.substr(i, 6), 36).toString();
          hp += (Math.floor(i / 6)) + "," + (new Date((parseInt(x.substr(0, x.length - 4)) + Math.pow(2, 14)) * 3600000 * 24).toISOString().replace(/-/g, '').split('T')[0]) + "," + x.substr(x.length - 4, 4) + ";";
        }
        catch (err) {
        }
      } o = hp;
    } return o;
  },
  animate: {
    slideIn(isBack, firstActivation = true) {
      const slideItems = document.querySelectorAll('.gsap-slide');
      const tl = new TimelineMax();

      if (isBack) {
        for (let i = 0; i < slideItems.length; i++) {
          tl.from(slideItems[i], 0.6, { x: -1000, opacity: 0 }, '-=0.4');
        }
      } else {
        if (firstActivation) {
          for (let i = 0; i < slideItems.length; i++) {
            tl.from(slideItems[i], 0.6, { x: 1000, opacity: 0 }, '-=0.4');
          }
        }
      }

    },
    slideOut() {
      const slideItems = document.querySelectorAll('.gsap-slide');
      const tl = new TimelineMax();
      for (let i = 0; i < slideItems.length; i++) {
        tl.to(slideItems[i], 0.75, { x: 500, opacity: 0 }, '-=0.4');
      }
    },
    fadeIn() {
      const fadeItems = document.querySelectorAll('.gsap-fade');
      const tl = new TimelineMax();
      for (let i = 0; i < fadeItems.length; i++) {
        tl.from(fadeItems[i], 0.75, { opacity: 0 }, '-=0.45');
      }
    },
    zoomIn() {
      const zoomItems = document.querySelectorAll('.gsap-zoom');
      const tl = new TimelineMax();
      for (let i = 0; i < zoomItems.length; i++) {
        tl.from(zoomItems[i], 0.75, { scaleX: 0, scaleY: 0, transformOrigin: 'center center' }, '-=0.45');
      }
    }
  },
  closest: function (target, tag) {
    return target.closest(tag);
  },
  getBackText() {
    let text = '';
    const g_state = this.getState();
    if (window.location.pathname == fa_path + '/scegli-dove') {
      if (g_state.prodotto == 1) {
        text = 'PRESTITO PERSONALE';
      } else if (g_state.prodotto == 4) {
        text = 'CARTA DI CREDITO';
      } else if (g_state.prodotto == 4) {
        text = '&nbsp;';
      }
    } else if (window.location.pathname == fa_path + '/data-appuntamento') {
      text = g_state.luogo;
    } else if (window.location.pathname == fa_path + '/scelta-filiale') {
      text = moment(g_state.data_appuntamento).format("dddd DD MMMM YYYY");
    }
    return text;
  },
  isCapExluded(address) {
    let excluded = false;
    if (address) {
      // const excluded_list = window.excluded || [];
      const excluded_list = excludedCapsMock || [];
      for (let ex in excluded_list) {
        const ex_cap = excluded_list[ex];
        if (address.indexOf(ex_cap) != -1) {
          excluded = true;
        }
      }
    }
    return excluded;
  },
  checkDateFormat(date) {
    const regex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
    
    return regex.test(date);
  },
  setDateFormat(date) {
    const isValid = this.checkDateFormat(date);
    
    if (!isValid) {
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6);

      return `${year}-${month}-${day}`;
    }

    return date;
  },
  objectIsEmpty(object) {
    if (Object.keys(object).length === 0 && object.constructor === Object) {
      return true;
    }
  
    return false;
  },
  getTotalMinutes(hour, minute) {
    return hour * 60 + minute;
  },
  sortAvailableHours(hours) {
    return hours.sort((a, b) => {
      return this.getTotalMinutes(a.hour, a.minute) - this.getTotalMinutes(b.hour, b.minute);
    })
  },
  simulateClick(targetElement) {
    if (targetElement) {
      targetElement.click();
    }
  },
  convertImportoValue(importo) {
    // const newImporto = importo.trim().replace(' ', '').toLowerCase();
    
    const enumImporto = {
      "Autonomo": "1",
      "Dipendente pubblico/statale": "2",
      "Dipendente SPA/SRL(+15 dip.)": "2",
      "Dipendente SPA/SRL(-15 dip.)": "2",
      "Dipendente SNC/SAS": "2",
      "Pensionato": "3",
      "Altro": "4",
    }

    Object.freeze(enumImporto);

    if (enumImporto[importo]) {
      return enumImporto[importo];
    }

    return importo;
  },
  elementInViewport(selector, percentage) {
    let el = window.document.querySelector(selector);
    let isInViewport = false;
    if (el) {
      if (!percentage) {
        percentage = 100; //Di default si deve vedere tutto l'elemento
      }
      let top = el.offsetTop;
      let left = el.offsetLeft;
      let width = el.offsetWidth;
      let height = el.offsetHeight / 100 * percentage;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }

      isInViewport = (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
      );
    }
    return isInViewport;
  },
  redirectToFa3(cf, coords, addr) {
    if (cf) {
      let url = "https://www.compass.it/fa3/";
      if (
        window.location.hostname == "compass-col.int.compassonline.it" ||
        window.location.hostname == "compassquinto-col.int.compassonline.it" ||
        window.location.hostname == "localhost") {
        url = "https://compass-col.int.compassonline.it/fa3/";
      }
      var redirect = url + "?cf=" + btoa(cf);
      if (coords) {
        redirect = redirect + '&coordinate=' + coords.lat + ',' + coords.lng;
      }
      if (addr) {
        redirect = redirect + '&indirizzo=' + addr;
      }
      window.location.href = redirect;
      /*apiInvoker.encodeToken(data, function (encoded) {
        const token = encoded.token;
        console.log("Token: " + token);
        window.location.href = '' + token;
      }, function (err) {
          console.log(err);
      });*/
    }
  },
  getFinalUserData(userData) {
    let finalUserData = { ...userData }
    
    if (userData.nome && userData.cognome) {
      if (!userData.email) {
        finalUserData.email = 'fallbackmail@monforte.it';
      }
  
      if (!userData.telefono) {
        finalUserData.telefono = '3388888888';
      }
  
      if (!userData.impiego) {
        finalUserData.impiego = '4';
      }
    } else {
      finalUserData.nome = null;
      finalUserData.cognome = null;
      finalUserData.email = null;
      finalUserData.telefono = null;
      finalUserData.cap = null;
    }

    return finalUserData;
  }
};

export default utils;


// WEBPACK FOOTER //
// ./src/modules/utils.js